export default "__VITE_ASSET__CGOElCY5__"